import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, IconButton, Badge } from '@mui/material';
import { Logout, Business } from '@mui/icons-material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import InventoryIcon from '@mui/icons-material/Inventory';
import Chat from '@mui/icons-material/Chat';


import myImage from "../CWSMANAGER LOGO.png";

const Sidebar = ({ onLogout, unreadMessages, totalCompanies, unactivecompany }) => {
  return (
    <Drawer
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',

          color: 'white',
          backgroundColor: '#05333F',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <div className="logo" style={{ padding: '20px', textAlign: 'center' }}>
        <img src={myImage} alt="Logo" style={{ width: '200px', height: 'auto' }} />
      </div>
      <Divider />
      <List>
        <ListItem button component="a" href="/companies">
          <ListItemIcon>
            <Badge
              badgeContent={unactivecompany}
              color="error"
              overlap="circular"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.75rem", // Adjust text size inside badge
                  minWidth: "20px", // Ensure circle shape
                  height: "20px",
                  borderRadius: "50%", // Make it circular
                },
              }}
            >
              <Business style={{ color: 'white' }} />
            </Badge>
          </ListItemIcon>
          <ListItemText style={{ color: 'white' }} primary="Unternehmen" />
        </ListItem>



        <ListItem button component="a" href="/requests">
          <ListItemIcon>
            <Badge
              badgeContent={totalCompanies}
              color="error"
              overlap="circular"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.75rem", // Adjust text size inside badge
                  minWidth: "20px", // Ensure circle shape
                  height: "20px",
                  borderRadius: "50%", // Make it circular
                },
              }}
            >
              <PendingActionsIcon style={{ color: "white" }} />
            </Badge>
          </ListItemIcon>
          <ListItemText style={{ color: "white" }} primary="Anfragen" />
        </ListItem>
        <ListItem button component="a" href="/archive">
          <ListItemIcon>
            <InventoryIcon style={{ color: 'white' }} />
          </ListItemIcon>
          <ListItemText style={{ color: 'white' }} primary="Archive" />
        </ListItem>

        <ListItem button component="a" href="/support">
          <ListItemIcon>
            <Badge
              badgeContent={unreadMessages}
              color="error"
              overlap="circular"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.75rem", // Adjust text size inside badge
                  minWidth: "20px", // Ensure circle shape
                  height: "20px",
                  borderRadius: "50%", // Make it circular
                },
              }}
            >
              <Chat style={{ color: 'white' }} />
            </Badge>
          </ListItemIcon>
          <ListItemText style={{ color: 'white' }} primary="Support" />
        </ListItem>


        <ListItem button onClick={onLogout}>
          <ListItemIcon>
            <Logout style={{ color: 'white' }} />
          </ListItemIcon>
          <ListItemText primary="Abmeldung" />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;
